export default "__VITE_ASSET__08457a7d__"